import {ChangeDetectionStrategy, Component, inject, OnInit, signal} from '@angular/core';
import {ShareholdersComponent} from './shareholders/shareholders.component';
import {ShareClassesComponent} from './share-classes/share-classes.component';
import {ClientShareClassHolder} from '@shared/interfaces/clientShareClassHolder';
import {ModalService} from '@shared/services/modal.service';
import {Router} from '@angular/router';
import {PARAM_ENTITY_ID} from '../../config/app-urls';
import {AppParameterMap} from '../../config/app-parameter-map';

@Component({
    selector: 'app-share-register',
    templateUrl: './share-register.component.html',
    styleUrls: ['./share-register.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShareClassesComponent]
})
export class ShareRegisterComponent implements OnInit {

  private readonly _router = inject(Router);
  private readonly _modalService = inject(ModalService);

  readonly entityId = signal('');

  ngOnInit() {
    const params = AppParameterMap.from(this._router);
    this.entityId.set(params.get(PARAM_ENTITY_ID));
  }

  showShareholdersHandler(clientShareClassHolder: ClientShareClassHolder) {
    this._modalService.openModal(ShareholdersComponent, clientShareClassHolder);
  }
}
